<!--
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-08-05 17:34:40
 * @LastEditTime: 2019-08-22 14:43:44
 * @LastEditors: Please set LastEditors
 -->
<template>
  <div>
    <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
      <el-tab-pane label="已报销统计（门店）" name="2">
        <el-form ref="form" :model="form" label-width="120px" :inline="true">
          <el-form-item label="报销时间:" style="text-align: center">
            <el-col :span="11">
              <el-date-picker
                type="date"
                placeholder="开始时间"
                v-model="form.start_time"
                style="width: 100%"
              ></el-date-picker>
            </el-col>
            <el-col class="line" :span="2">-</el-col>
            <el-col :span="11">
              <el-date-picker
                type="date"
                placeholder="结束时间"
                v-model="form.end_time"
                style="width: 100%"
              ></el-date-picker>
            </el-col>
          </el-form-item>
          <el-form-item label="产品编号:">
            <el-input v-model="form.product_sn" clearable></el-input>
          </el-form-item>
          <el-form-item label="产品名称:">
            <el-input v-model="form.product_name" clearable></el-input>
          </el-form-item>
          <el-form-item style="margin-left: 100px">
            <el-button type="primary" @click="onSearch()">搜索</el-button>
            <!-- <el-button type="primary" @click="onExport()">导出</el-button> -->
          </el-form-item>
        </el-form>
        <div style="padding-left: 50px">
          已报销总数
          <span style="color: #f04635">{{ total }}</span>
        </div>
        <el-table
          ref="multipleTable"
          :data="tableData"
          v-loading="loading"
          border
          stripe
          style="width: 97.5%; margin: 20px"
        >
          <el-table-column label="序号" fixed width="80"
            ><template slot-scope="scope">{{ scope.$index }}</template></el-table-column
          >
          <el-table-column
            prop="expense_id"
            label="报销单号"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            prop="create_time"
            label="报销时间"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            prop="state"
            label="报销状态"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            prop="w_expense_num"
            label="报销数量"
            show-overflow-tooltip
          ></el-table-column>

          <el-table-column prop label="操作" width="160" show-overflow-tooltip>
            <template slot-scope="scope">
              <el-button type="text" size="small" @click="detail(scope.row.id)"
                >查看明细</el-button
              >
            </template>
          </el-table-column>
        </el-table>

        <el-pagination
          style="margin: 20px 0"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pageNo"
          :page-sizes="[20, 50, 100, 200]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalSize"
        ></el-pagination>
      </el-tab-pane>
      <el-tab-pane label="未报销统计(门店)" name="3">
        <el-form ref="form1" :model="form1" label-width="120px" :inline="true">
          <!-- <el-form-item label="产品编号:">
            <el-input v-model="form1.product_sn" clearable></el-input>
          </el-form-item>
          <el-form-item label="产品名称:">
            <el-input v-model="form1.product_name" clearable></el-input>
          </el-form-item>
          <el-form-item style="margin-left: 100px">
            <el-button type="primary" @click="onSearch()">搜索</el-button>
            <el-button type="primary" @click="onExport()">导出</el-button>
          </el-form-item> -->
        </el-form>
        <div style="padding-left: 40px">
          已报销总数
          <span style="color: #f04635">{{ sum_already_expense_num }}</span>
          未报销总数
          <span style="color: #f04635">{{ sum_not_expense_num }}</span>
        </div>
        <el-table
          ref="multipleTable"
          :data="tableData1"
          v-loading="loading"
          border
          stripe
          style="width: 100%; margin: 20px"
        >
          <el-table-column prop label="序号" fixed
            ><template slot-scope="scope">{{ scope.$index }}</template></el-table-column
          >
          <el-table-column prop="product_image" label="礼品图片">
            <template slot-scope="scope">
              <div>
                <img :src="scope.row.product_image" height="50" width="50" alt="" />
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="product_number"
            label="产品编号"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            prop="product_name"
            label="产品名称"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            prop="already_expense_num"
            label="已报销数量"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            prop="not_expense_num"
            label="未报销数量"
            show-overflow-tooltip
          ></el-table-column>
          <!-- <el-table-column
            prop="real_stock_out_num"
            label="操作"
            width="160"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <el-button type="text" size="small" @click="detail(scope.row)"
                >明细</el-button
              >
            </template>
          </el-table-column> -->
        </el-table>
        <el-pagination
          style="margin: 20px 0"
          @size-change="handleSizeChange1"
          @current-change="handleCurrentChange1"
          :current-page="pageNo1"
          :page-sizes="[5, 10, 20, 100]"
          :page-size="pageSize1"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalSize1"
        ></el-pagination>
      </el-tab-pane>
    </el-tabs>
    <!--选择经销商/门店-->
    <selectRole
      v-if="selectRoleDialog"
      v-on:handleClose="selectRoleDialog = false"
      @pushData="getSelectinfo"
    >
    </selectRole>
    <el-dialog
      :visible.sync="detailDialog"
      width="50%"
      title="报销明细"
      v-on:handleClose="(detailDialog = false), (pageSize2 = 20), (pageNo2 = 1)"
    >
      <!-- <el-button size="small" @click="exportDetail()" style="margin-bottom: 10px"
        >导出明细</el-button
      > -->
      <el-table :data="tableData2" style="width: 100%" border v-loading="loading2">
        <el-table-column prop="product_image" label="礼品图片">
          <template slot-scope="scope">
            <div>
              <img :src="scope.row.product_image" height="50" width="50" alt="" />
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="product_number" label="礼品编号" v-if="activeName == 2">
        </el-table-column>
        <el-table-column prop="product_name" label="礼品名称" v-if="activeName == 2">
        </el-table-column>
        <el-table-column prop="product_num" label="报销数量" v-if="activeName == 2">
        </el-table-column>
      </el-table>
      <!--分页-->
      <el-pagination
        style="margin: 20px 0"
        @size-change="handleSizeChange2"
        @current-change="handleCurrentChange2"
        :current-page="pageNo2"
        :page-sizes="[5, 10, 20, 50]"
        :page-size="pageSize2"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalSize2"
      >
      </el-pagination>
    </el-dialog>
  </div>
</template>

<script>
import selectRole from "@/common/selectRole";

export default {
  name: "my",
  data() {
    return {
      selectRoleDialog: false,
      form1: {
        to_sn: "",
        end_time: "",
        start_time: "",
        stock_out_sn: "",
        product_sn: "",
        product_name: "",
        to_type: "",
        keywords: "",
      },
      form: {
        to_sn: "",
        end_time: "",
        start_time: "",
        stock_out_sn: "",
        product_sn: "",
        product_name: "",
        to_type: "",
        keywords: "",
      },
      activeName: "2",
      loading: false,
      loading2: false,
      pageNo1: 1,
      pageSize1: 20,
      totalSize1: 0,
      tableData: [],
      tableData1: [],
      tableData2: [],
      total: 0,
      pageNo: 1,
      pageSize: 20,
      totalSize: 0,
      pageNo2: 1,
      pageSize2: 20,
      totalSize2: 0,
      detailDialog: false,
      detailData: {},
      expense_id: "", //报销单id
      sum_already_expense_num: 0,
      sum_not_expense_num: 0,
    };
  },
  methods: {
    onSearch() {
      this.loading = true;
      if (this.activeName == 2) {
        if (this.form.start_time) {
          this.form.start_time = this.moment(this.form.start_time).format("YYYY-MM-DD");
        }
        if (this.form.end_time) {
          this.form.end_time = this.moment(this.form.end_time).format("YYYY-MM-DD");
        }
        this.$get("logistics_2", "/vstore/dealer_pc/lowerDealerStoreExpenseAlist", {
          ...this.form,
          per_page: this.pageSize,
          page: this.pageNo,
          store_sn: this.$route.query.store_sn,
        }).then((res) => {
          this.loading = false;
          this.tableData = res.data.data;
          this.totalSize = res.data.total;
          this.total = res.data.sum_expense_num;
        });
      } else {
        if (this.form1.start_time) {
          this.form1.start_time = this.moment(this.form1.start_time).format("YYYY-MM-DD");
        }
        if (this.form1.end_time) {
          this.form1.end_time = this.moment(this.form1.end_time).format("YYYY-MM-DD");
        }
        this.$get("logistics_2", "/vstore/dealer_pc/lowerDealerStoreExpenseNlist", {
          ...this.form,
          per_page: this.pageSize,
          page: this.pageNo,
          store_sn: this.$route.query.store_sn,
        }).then((res) => {
          this.totalSize1 = res.data.total;
          this.tableData1 = res.data.data;
          this.total = res.data.total;
          this.sum_already_expense_num = res.data.sum_already_expense_num;
          this.sum_not_expense_num = res.data.sum_not_expense_num;
          this.loading = false;
        });
      }
    },
    onExport() {
      let url = "",
        access_tokens = localStorage.getItem("access_token");

      if (this.activeName == 2) {
        let beginstr = "",
          endstr = "";
        if (this.form.start_time) {
          beginstr = this.moment(this.form.start_time).format("YYYY-MM-DD");
        }
        if (this.form.end_time) {
          endstr = this.moment(this.form.end_time).format("YYYY-MM-DD");
        }

        window.open(
          process.env.VUE_APP_URL +
            "/stocks.outstocks.export?start_time=" +
            beginstr +
            "&end_time=" +
            endstr +
            "&stock_out_sn=" +
            this.form.stock_out_sn +
            "&product_sn=" +
            this.form.product_sn +
            "&product_name=" +
            this.form.product_name +
            "&to_type=" +
            this.form.to_type +
            "&to_sn=" +
            this.form.to_sn +
            "&lang=" +
            "" +
            "&is_export=1" +
            "&keywords=" +
            this.form1.keywords +
            "&signature=" +
            this.$md5(access_tokens)
        );
      } else {
        let beginstr = "",
          endstr = "";
        if (this.form1.start_time) {
          beginstr = this.moment(this.form1.start_time).format("YYYY-MM-DD");
        }
        if (this.form1.end_time) {
          endstr = this.moment(this.form1.end_time).format("YYYY-MM-DD");
        }
        window.open(
          process.env.VUE_APP_URL +
            "/stocks.outproducts.export?start_time=" +
            beginstr +
            "&end_time=" +
            endstr +
            "&stock_out_sn=" +
            this.form1.stock_out_sn +
            "&product_sn=" +
            this.form1.product_sn +
            "&product_name=" +
            this.form1.product_name +
            "&to_type=" +
            this.form1.to_type +
            "&to_sn=" +
            this.form1.to_sn +
            "&lang=" +
            "" +
            "&is_export=1" +
            "&keywords=" +
            this.form1.keywords +
            "&signature=" +
            this.$md5(access_tokens)
        );
      }
    },
    detail(data) {
      this.expense_id = data;
      this.detailDialog = true;
      if (data) {
        this.detailData = data;
      }
      this.loading2 = true;
      this.tableData2 = [];
      if (this.activeName == 2) {
        this.$get("logistics_2", "/vstore/dealer_pc/lowerDealerStoreExpenseDetail", {
          per_page: this.pageSize2,
          page: this.pageNo2,
          store_expense_id: this.expense_id,
        }).then((res) => {
          this.tableData2 = res.data.data;
          this.totalSize2 = res.data.total;
          this.loading2 = false;
        });
      } else {
        this.$get("logistics", "/stocks.outproducts/datas", {
          per_page: this.pageSize2,
          page: this.pageNo2,
          product_sn: this.detailData.product_sn,
        }).then((res) => {
          this.tableData2 = res.data;
          this.totalSize2 = res.meta.total;
          this.loading = false;
        });
      }
    },
    exportDetail() {
      let access_tokens = localStorage.getItem("access_token");

      if (this.activeName == 2) {
        window.open(
          process.env.VUE_APP_URL +
            "/stocks.outstocks/datas.export" +
            "?to_type=" +
            this.detailData.to_type +
            "&to_sn=" +
            this.detailData.to_sn +
            "&lang=" +
            "" +
            "&is_export=1" +
            "&signature=" +
            this.$md5(access_tokens)
        );
      } else {
        window.open(
          process.env.VUE_APP_URL +
            "/stocks.outproducts/datas.export" +
            "?product_sn=" +
            this.detailData.product_sn +
            "&lang=" +
            "" +
            "&is_export=1" +
            "&signature=" +
            this.$md5(access_tokens)
        );
      }
    },
    getSelectinfo(val) {
      if (this.activeName == 2) {
        if (val.dealer_sn) {
          this.form.to_sn = val.dealer_sn;
          this.form.to_type = 2;
        } else {
          this.form.to_sn = val.shop_sn;
          this.form.to_type = 3;
        }
      } else {
        if (val.dealer_sn) {
          this.form1.to_sn = val.dealer_sn;
          this.form1.to_type = 2;
        } else {
          this.form1.to_sn = val.shop_sn;
          this.form1.to_type = 3;
        }
      }
    },
    getLastMonth() {
      var now = new Date();
      var year = now.getFullYear(); //getYear()+1900=getFullYear()
      var month = now.getMonth() + 1; //0-11表示1-12月
      var day = now.getDate();
      var dateObj = {};
      if (parseInt(month) < 10) {
        month = "0" + month;
      }
      if (parseInt(day) < 10) {
        day = "0" + day;
      }

      dateObj.now = year + "-" + month + "-" + day;

      if (parseInt(month) == 1) {
        //如果是1月份，则取上一年的12月份
        dateObj.last = parseInt(year) - 1 + "-12-" + day;
        return dateObj;
      }

      var preSize = new Date(year, parseInt(month) - 1, 0).getDate(); //上月总天数
      if (preSize < parseInt(day)) {
        //上月总天数<本月日期，比如3月的30日，在2月中没有30
        dateObj.last = year + "-" + month + "-01";
        return dateObj;
      }

      if (parseInt(month) <= 10) {
        dateObj.last = year + "-0" + (parseInt(month) - 1) + "-" + day;
        return dateObj;
      } else {
        dateObj.last = year + "-" + (parseInt(month) - 1) + "-" + day;
        return dateObj;
      }
    },
    handleSizeChange1(val) {
      this.pageSize1 = val;
      this.pageNo1 = 1;
      this.onSearch();
    },
    handleCurrentChange1(val) {
      this.pageNo1 = val;
      this.onSearch();
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.pageNo = 1;
      this.onSearch();
    },
    handleCurrentChange(val) {
      this.pageNo = val;
      this.onSearch();
    },
    handleSizeChange2(val) {
      this.pageSize2 = val;
      this.pageNo2 = 1;
      this.detail(this.expense_id);
    },
    handleCurrentChange2(val) {
      this.pageNo2 = val;
      this.detail(this.expense_id);
    },
    handleClick() {
      this.onSearch();
    },
  },
  created() {
    this.form.start_time = this.getLastMonth().last;
    this.form.end_time = this.getLastMonth().now;
    this.form1.start_time = this.getLastMonth().last;
    this.form1.end_time = this.getLastMonth().now;
    this.onSearch();
  },
  components: {
    selectRole,
  },
};
</script>
